export class GraphQLFragmentError extends Error {
	constructor(message: string) {
		super(message);
		this.name = 'GraphQLFragmentError';
		this.message = message;
	}
}
